import React, { useState } from 'react';
import { updateNote } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const EditNoteModal = ({ note, onClose, onNoteUpdated }) => {
    const [text, setText] = useState(note.text);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!text) {
            setError('Please enter a note.');
            return;
        }

        try {
            await updateNote(note.id, { text });
            onNoteUpdated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Edit Note</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <textarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows="5"
                        />
                    </div>
                    <div className="actions-centered">
                        <button type="submit" className="submit-button text-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditNoteModal;